export const headers = [
  "id",
  "isHistorical",
  "catalogId",
  "catalogName",
  "catalogTemplate",
  "pmxReleaseId",
  "territoryName",
  "productType",
  "productConfig",
  "productPlatform",
  "superPremiumEHVLStartDate",
  "superPremiumEHVLStartDateStatus",
  "superPremiumEHVLTier",
  "superPremiumEHVLPrice",
  "newReleasePEHVStartDate",
  "newReleasePEHVStartDateStatus",
  "premiumEHVLTier",
  "premiumEHVLPrice",
  "newReleaseEHVLStartDate",
  "newReleaseEHVLStartDateStatus",
  "currencyCodeFlexiPrice",
  "newReleaseEHVLTier",
  "newReleaseEHVLPrice",
  "newReleaseEHVLEpisodeTier",
  "newReleaseEHVLEpisodePrice",
  "newtoCatalogEHVLStartDate",
  "newtoCatalogEHVLStartDateStatus",
  "newtoCatalogEHVLTier",
  "newtoCatalogEHVLPrice",
  "catalogEHVLStartDate",
  "catalogEHVLStartDateStatus",
  "catalogEHVLTier",
  "catalogEHVLPrice",
  "catalogEHVLEpisodeTier",
  "catalogEHVLEpisodePrice",
  "presellStartEHVDate",
  "presellStartEHVDateStatus",
  "suppressionLiftEHVDate",
  "suppressionLiftEHVStatus",
  "setPrice",
  "currencyCodeSetPrice",
  "tvodSuperPremiumStartDate",
  "tvodSuperPremiumStartDateStatus",
  "tvodSuperPremiumTier",
  "tvodSuperPremiumLicenseFee",
  "tvodSuperPremiumMinDeemedPrice",
  "pvodNewReleaseStartDate",
  "pvodNewReleaseStartDateStatus",
  "tvodPremiumTier",
  "tvodPremiumLicenseFee",
  "tvodPremiumMinDeemedPrice",
  "tvodCurrentStartDate",
  "tvodCurrentStartDateStatus",
  "currencyCodeLicenseFee",
  "currencyCodeMinDeemedPrice",
  "tvodCurrentTier",
  "tvodCurrentLicenseFee",
  "tvodCurrentMinDeemedPrice",
  "tvodCurrentEpisodeTier",
  "tvodCurrentEpisodePrice",
  "tvodLibraryStartDate",
  "tvodLibraryStartDateStatus",
  "tvodLibraryTier",
  "tvodLibraryLicensedFee",
  "tvodLibraryMinDeemedPrice",
  "tvodLibraryEpisodeTier",
  "tvodLibraryEpisodePrice",
  "suppressionLiftVODDate",
  "suppressionLiftVODStatus",
  "physicalDate",
  "physicalStatus",
  "physicalRetailPrice",
  "currencyCodeWholesalePrice",
  "physicalWholesalePrice",
  "presellStartPhysicalDate",
  "presellStartPhysicalStatus",
  "createdAt",
  "modifiedAt",
];

export const renamedHeaders = [
  "Id",
  "Historical Record from RL?",
  "Catalog Id",
  "Catalog",
  "Catalog Template",
  "PMX Release ID",
  "Territory",
  "Product Type",
  "Product Config",
  "Product Platform",
  "Super Premium EHVL Start Date",
  "Super Premium EHVL Start Date Status",
  "Super Premium EHVL Tier",
  "Super Premium EHVL Price",
  "Premium EHVL Start Date",
  "Premium EHVL Start Date Status",
  "Premium EHVL Tier",
  "Premium EHVL Price",
  "New Release EHVL Start Date",
  "New Release EHVL Start Date Status",
  "Currency Code EHVL Price",
  "New Release EHVL Tier",
  "New Release EHVL Price",
  "New Release EHVL Episode Tier",
  "New Release EHVL Episode Price",
  "New to Catalog EHVL Start Date",
  "New to Catalog EHVL Start Date Status",
  "New to Catalog EHVL Tier",
  "New to Catalog EHVL Price",
  "Catalog EHVL Start Date",
  "Catalog EHVL Start Date Status",
  "Catalog EHVL Tier",
  "Catalog EHVL Price",
  "Catalog EHVL Episode Tier",
  "Catalog EHVL Episode Price",
  "Pre-Sell EHVL Start Date",
  "Pre-Sell EHVL Start Date Status",
  "EHVL Suppression Lift Date",
  "EHVL Suppression Lift Date Status",
  "EHVL Set Price",
  "Currency Code EHVL Set Price",
  "TVOD Super Premium Start Date",
  "TVOD Super Premium Start Date Status",
  "TVOD Super Premium Tier",
  "TVOD Super Premium License Fee",
  "TVOD Super Premium Min Deemed Price",
  "TVOD Premium Start Date",
  "TVOD Premium Start Date Status",
  "TVOD Premium Tier",
  "TVOD Premium License Fee",
  "TVOD Premium Min Deemed Price",
  "TVOD Current Start Date",
  "TVOD Current Start Date Status",
  "Currency Code TVOD License Fee",
  "Currency Code TVOD Min Deemed Price",
  "TVOD Current Tier",
  "TVOD Current License Fee",
  "TVOD Current Min Deemed Price",
  "TVOD Current Episode Tier",
  "TVOD Current Episode Price",
  "TVOD Library Start Date",
  "TVOD Library Start Date Status",
  "TVOD Library Tier",
  "TVOD Library License Fee",
  "TVOD Library Min Deemed Price",
  "TVOD Library Episode Tier",
  "TVOD Library Episode Price",
  "TVOD Suppression Lift Date",
  "TVOD Suppression Lift Date Status",
  "Physical Date",
  "Physical Status",
  "Physical Retail Price",
  "Currency Code Wholesale Price",
  "Physical Wholesale Price",
  "Pre-Sell Start Physical Date",
  "Pre-Sell Start Physical Status",
  "Created",
  "Modified",
];
